export const backMoveText = {
  values: [
    { value: 'BackMove', text: 'Ja', score: 1 },
    { value: 'BackMove', text: 'Nei', score: 0 },
  ],
};
